// FitClutch — funil web — textos em italiano
export default {
  'ageSelect.titleLine1': 'Crea il tuo',
  'ageSelect.titleHighlight': 'Piano di Allenamento Personalizzato',
  'ageSelect.poweredBy': 'Powered by FitClutch AI',
  'ageSelect.subtitle': 'Scegli la tua fascia d’età per iniziare',
  'ageSelect.duration': 'Quiz di 3 minuti',
  'ageSelect.ageLabel': 'Età: {range}',
  'ageSelect.footnote': 'Continuando, accetti i nostri {terms} e la nostra {privacy}.',
  'ageSelect.termsLink': 'Termini di Utilizzo',
  'ageSelect.privacyLink': 'Informativa sulla Privacy',

  'gender.title': 'Qual è il tuo genere?',
  'gender.subtitle': 'Lo usiamo solo per personalizzare il tuo piano',
  'gender.male': 'Uomo',
  'gender.female': 'Donna',
  'gender.other': 'Preferisco non dirlo',

  'socialProof.genderWomen': 'donne',
  'socialProof.genderMen': 'uomini',
  'socialProof.genderPeople': 'persone',
  'socialProof.decade20': 'nei loro 20 anni',
  'socialProof.decade30': 'nei loro 30 anni',
  'socialProof.decade40': 'nei loro 40 anni',
  'socialProof.decade50': 'nei loro 50 anni o più',
  'socialProof.headlineBig': 'Oltre {users} {gender}',
  'socialProof.subcopy': '{decade} si fidano già di FitClutch per <hl>raggiungere i loro obiettivi, in base al livello di allenamento e all’attrezzatura disponibile</hl>. Si adatta mentre migliori.',
  'socialProof.subcopyNoDecade': 'si fidano già di FitClutch per <hl>raggiungere i loro obiettivi, in base al livello di allenamento e all’attrezzatura disponibile</hl>. Si adatta mentre migliori.',
  'socialProof.downloadsLabel': 'Download',
  'socialProof.cta': 'Continua',

  'goal.question': 'Qual è il tuo obiettivo fitness principale?',
  'goal.option_hipertrofia': 'Aumentare la massa muscolare',
  'goal.option_emagrecer': 'Perdere peso',
  'goal.option_forca': 'Diventare più forte',
  'goal.option_condicionamento': 'Migliorare la forma fisica generale',
  'goal.feedbackLead': 'Perfetto:',
  'goal.feedback_hipertrofia': 'sessioni di forza personalizzate, con forma guidata in video per ogni ripetizione.',
  'goal.feedback_emagrecer': 'un piano pensato per mantenere il metabolismo attivo.',
  'goal.feedback_forca': 'progressione del carico sicura per diventare davvero più forte.',
  'goal.feedback_condicionamento': 'sessioni equilibrate per migliorare resistenza, mobilità ed energia.',

  'bodyShape.question': 'Quale descrive meglio il tuo corpo oggi?',
  'bodyShape.option_magro_male': 'Snello',
  'bodyShape.option_magro_female': 'Snella',
  'bodyShape.option_magro_neutral': 'Corpo snello',
  'bodyShape.option_cheio_male': 'Più pieno',
  'bodyShape.option_cheio_female': 'Più piena',
  'bodyShape.option_cheio_neutral': 'Corpo più pieno',
  'bodyShape.option_atletico_male': 'Atletico',
  'bodyShape.option_atletico_female': 'Atletica',
  'bodyShape.option_atletico_neutral': 'Corpo atletico',
  'bodyShape.option_definido_male': 'Tonico',
  'bodyShape.option_definido_female': 'Tonica',
  'bodyShape.option_definido_neutral': 'Corpo tonico',
  'bodyShape.option_medio_male': 'Medio',
  'bodyShape.option_medio_female': 'Media',
  'bodyShape.option_medio_neutral': 'Corpo medio',

  'bodyGoal.question': 'Che fisico vuoi raggiungere?',
  'bodyGoal.option_definido_male': 'Definito e tonico',
  'bodyGoal.option_definido_female': 'Definita e tonica',
  'bodyGoal.option_definido_neutral': 'Corpo definito e tonico',
  'bodyGoal.option_atletico_male': 'Atletico e muscoloso',
  'bodyGoal.option_atletico_female': 'Atletica e in forma',
  'bodyGoal.option_atletico_neutral': 'Corpo atletico e muscoloso',
  'bodyGoal.option_magro_male': 'Snello e leggero',
  'bodyGoal.option_magro_female': 'Snella e leggera',
  'bodyGoal.option_magro_neutral': 'Corpo snello e leggero',
  'bodyGoal.option_curvilineo_male': 'Forte e robusto',
  'bodyGoal.option_curvilineo_female': 'Forte e con curve',
  'bodyGoal.option_curvilineo_neutral': 'Corpo forte e definito',

  'lastBest.question': 'Quando ti sei sentito/a al meglio fisicamente l’ultima volta?',
  'lastBest.option_agora': 'Proprio ora',
  'lastBest.option_menos_1_ano': 'Meno di un anno fa',
  'lastBest.option_1_3_anos': 'Da 1 a 3 anni fa',
  'lastBest.option_mais_3_anos': 'Più di 3 anni fa',
  'lastBest.option_nunca': 'Mai',

  'weightTrend.question': 'Come varia di solito il tuo peso?',
  'weightTrend.option_estavel': 'Abbastanza stabile',
  'weightTrend.option_varia': 'Sale e scende in base alle mie abitudini',
  'weightTrend.option_subindo': 'Sta salendo costantemente',
  'weightTrend.option_caindo': 'Sta scendendo costantemente',
  'weightTrend.option_nao_sei': 'Non sono sicuro/a',

  'transformPromo.headline': 'Il tuo obiettivo: {target}. Ti mostriamo esattamente come arrivarci.',
  'transformPromo.subcopyLead': 'Allenati senza paura di infortunarti. FitClutch ha',
  'transformPromo.subcopyHighlight1': 'video dimostrativi',
  'transformPromo.subcopyMid': 'per ogni esercizio, per aiutarti a eseguire la forma corretta e',
  'transformPromo.subcopyHighlight2': 'evitare infortuni',
  'transformPromo.cta': 'Continua',

  'pushUps.question': 'Qual è il tuo massimo di flessioni di fila?',
  'pushUps.option_nenhuma': 'Ancora nessuna',
  'pushUps.option_1_5': 'Da 1 a 5',
  'pushUps.option_6_15': 'Da 6 a 15',
  'pushUps.option_16_30': 'Da 16 a 30',
  'pushUps.option_30_mais': 'Più di 30',

  'squats.question': 'Quanti squat riesci a fare di fila senza fermarti?',
  'squats.option_nenhuma': 'Ancora nessuno',
  'squats.option_1_10': 'Da 1 a 10',
  'squats.option_11_25': 'Da 11 a 25',
  'squats.option_26_50': 'Da 26 a 50',
  'squats.option_50_mais': 'Più di 50',

  'flexibility.question': 'Quanto sei flessibile?',
  'flexibility.option_nao_alcanco': 'Non riesco a toccare i piedi',
  'flexibility.option_quase': 'Riesco quasi a toccare i piedi',
  'flexibility.option_facil': 'Tocco i piedi senza sforzo',
  'flexibility.option_muito_flexivel': 'Molto flessibile (spaccata, stretching profondo)',
  'flexibility.option_nao_sei': 'Non lo so',

  'progressPromo.headline': 'Il tuo punto di partenza è fissato. Ora vediamolo muoversi.',
  'progressPromo.subcopyLead': 'Ogni allenamento viene',
  'progressPromo.subcopyHighlight': 'registrato automaticamente',
  'progressPromo.subcopyTail': '— statistiche in tempo reale per tenerti motivato.',
  'progressPromo.cta': 'Continua',

  'focusArea.question': 'Quali sono le tue zone target?',
  'focusArea.subtitle': 'Scegli una zona specifica o "Corpo intero".',
  'focusArea.option_superior': 'Parte superiore',
  'focusArea.option_core': 'Core / Addominali',
  'focusArea.option_inferior': 'Parte inferiore',
  'focusArea.option_corpo_inteiro': 'Corpo intero',
  'focusArea.cta': 'Continua',

  'injuries.question': 'C’è una zona che richiede più attenzione?',
  'injuries.subtitle': 'Adatteremo i tuoi esercizi per proteggere quelle zone.',
  'injuries.option_ombros': 'Spalle',
  'injuries.option_joelhos': 'Ginocchia',
  'injuries.option_costas': 'Schiena',
  'injuries.option_nenhuma': 'Nessuna',
  'injuries.disclaimer': 'Adattamenti preventivi — non sostituiscono una valutazione medica.',
  'injuries.cta': 'Continua',

  'workoutDuration.question': 'Qual è la durata ideale del tuo allenamento?',
  'workoutDuration.option_rapido': 'Veloce',
  'workoutDuration.option_rapido_subtitle': '3 esercizi',
  'workoutDuration.option_rapido_badge': 'Fino a 20 min',
  'workoutDuration.option_curto': 'Breve',
  'workoutDuration.option_curto_subtitle': '4-6 esercizi',
  'workoutDuration.option_curto_badge': '20-40 min',
  'workoutDuration.option_medio': 'Medio',
  'workoutDuration.option_medio_subtitle': '5-7 esercizi',
  'workoutDuration.option_medio_badge': '40-60 min',
  'workoutDuration.option_longo': 'Lungo',
  'workoutDuration.option_longo_subtitle': '8-10 esercizi',
  'workoutDuration.option_longo_badge': '60+ min',

  'trainingSummaryPromo.headline': '{days}, sessioni da {duration} — in arrivo.',
  'trainingSummaryPromo.subcopyLead': 'Direttamente dalla nostra',
  'trainingSummaryPromo.subcopyHighlight': 'libreria di allenamenti',
  'trainingSummaryPromo.subcopyTail': ', c’è sempre uno pronto per te.',
  'trainingSummaryPromo.cta': 'Continua',
  'trainingSummaryPromo.days_2': '1-2x a settimana',
  'trainingSummaryPromo.days_4': '3-4x a settimana',
  'trainingSummaryPromo.days_6': '5-6x a settimana',
  'trainingSummaryPromo.days_7': 'Tutti i giorni',

  'workSchedule.question': 'Com’è la tua routine lavorativa?',
  'workSchedule.option_fixo': 'Orario d’ufficio',
  'workSchedule.option_noturno': 'Turno notturno',
  'workSchedule.option_flexivel': 'Orario flessibile',
  'workSchedule.option_parado': 'Non sto lavorando',

  'dailyActivity.question': 'Quanto è attiva la tua giornata tipo?',
  'dailyActivity.option_sentado': 'Principalmente seduto/a',
  'dailyActivity.option_ativo': 'In piedi o in movimento',
  'dailyActivity.option_misto': 'Un po’ di entrambi',
  'dailyActivity.option_nao_sei': 'Non sono sicuro/a',

  'sleepHours.question': 'Quante ore dormi di solito?',
  'sleepHours.option_menos_5': 'Meno di 5 ore',
  'sleepHours.option_5_6': '5-6 ore',
  'sleepHours.option_7_8': '7-8 ore',
  'sleepHours.option_mais_8': 'Più di 8 ore',

  'waterIntake.question': 'Quanti bicchieri d’acqua bevi al giorno?',
  'waterIntake.subtitle': 'Tocca il numero più vicino alla tua routine.',
  'waterIntake.cta': 'Continua',

  'profileSummary.headline': 'Ecco il tuo profilo',
  'profileSummary.imcLabel': 'IMC - {imc}',
  'profileSummary.imcAbaixo': 'Sotto',
  'profileSummary.imcNormal': 'Normale',
  'profileSummary.imcAcima': 'Sopra',
  'profileSummary.imcObeso': 'Obeso',
  'profileSummary.bodyTypeLabel': 'Tipo di corpo',
  'profileSummary.bodyType_ectomorfo': 'Ectomorfo',
  'profileSummary.bodyType_mesomorfo': 'Mesomorfo',
  'profileSummary.bodyType_endomorfo': 'Endomorfo',
  'profileSummary.lifestyleLabel': 'Stile di vita',
  'profileSummary.lifestyle_sedentario': 'Sedentario',
  'profileSummary.lifestyle_ativo': 'Attivo',
  'profileSummary.lifestyle_equilibrado': 'Equilibrato',
  'profileSummary.conditioningLabel': 'Livello di forma fisica',
  'profileSummary.conditioning_iniciante': 'Base',
  'profileSummary.conditioning_intermediario': 'Intermedio',
  'profileSummary.conditioning_avancado': 'Avanzato',
  'profileSummary.conditioning_especialista': 'Esperto',
  'profileSummary.metabolismLabel': 'Metabolismo',
  'profileSummary.metabolism_lento': 'Lento, prende peso facilmente',
  'profileSummary.metabolism_acelerado': 'Veloce, perde peso facilmente',
  'profileSummary.metabolism_equilibrado': 'Equilibrato',
  'profileSummary.metabolism_variavel': 'Variabile, dipende dalle abitudini',
  'profileSummary.cta': 'Continua',

  'barriers.question': 'Cosa ti ha impedito di metterti in forma prima?',
  'barriers.option_motivacao': 'Poca motivazione',
  'barriers.option_sem_plano': 'Nessun piano strutturato',
  'barriers.option_tempo': 'Mancanza di tempo',
  'barriers.option_lesoes': 'Infortuni fisici',
  'barriers.option_outro': 'Altri motivi',

  'consistencyChart.headline': 'FitClutch ti aiuta a restare costante!',
  'consistencyChart.subcopyLead': 'Il tuo piano personalizzato ha tutto ciò che serve per',
  'consistencyChart.subcopyHighlight1': 'mantenere alta la motivazione',
  'consistencyChart.subcopyMid': 'e',
  'consistencyChart.subcopyHighlight2': 'raggiungere il fisico che desideri',
  'consistencyChart.chartTitle': 'La tua evoluzione',
  'consistencyChart.nowLabel': 'Ora',
  'consistencyChart.withLabel': 'Con FitClutch',
  'consistencyChart.withoutLabel': 'Senza FitClutch',
  'consistencyChart.disclaimer': 'Avviso: gli esempi sono illustrativi. Restare costanti negli allenamenti e nell’alimentazione è ciò che porta davvero ai risultati.',
  'consistencyChart.cta': 'Continua',

  'progressLoader.headline': 'Creando il tuo Piano di Allenamento Personale',
  'progressLoader.item_bodyType': 'Adattamento al tuo tipo di corpo e routine',
  'progressLoader.item_fitnessLevel': 'Valutazione del tuo livello di forma fisica',
  'progressLoader.item_plan': 'Creazione del tuo piano personalizzato',
  'progressLoader.testimonial1_title': 'Ha cambiato la mia routine',
  'progressLoader.testimonial1_body': 'Finalmente un piano che si adatta davvero alla mia settimana. Facile da seguire e gli allenamenti hanno senso.',
  'progressLoader.testimonial1_author': 'Renata A.',
  'progressLoader.testimonial2_title': 'Risultati reali',
  'progressLoader.testimonial2_body': 'In poche settimane ho già sentito la differenza in energia e forza. Il piano si adatta a me.',
  'progressLoader.testimonial2_author': 'Juliana M.',
  'progressLoader.testimonial3_title': 'Una routine che riesco a mantenere',
  'progressLoader.testimonial3_body': 'Non ero mai riuscita a mantenere una routine prima di FitClutch. Ora fa parte della mia giornata.',
  'progressLoader.testimonial3_author': 'Carla S.',
  'progressLoader.testimonial4_title': 'Ne vale davvero la pena',
  'progressLoader.testimonial4_body': 'Semplice, diretto e pensato davvero per il mio corpo e la mia routine.',
  'progressLoader.testimonial4_author': 'Fernanda O.',

  'emailCapture.headlineLead': 'Inserisci la tua email per ricevere il tuo',
  'emailCapture.headlineHighlight': 'Piano di Allenamento Personalizzato',
  'emailCapture.placeholder': 'tuaemail@esempio.com',
  'emailCapture.cta': 'Continua',
  'emailCapture.privacyLead': 'Rispettiamo la tua privacy e proteggiamo i tuoi dati personali, in conformità con la nostra',
  'emailCapture.privacyLink': 'Informativa sulla Privacy',
};
